"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseStore = require("fluxible/addons/BaseStore");
class ApplicationStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.dispatcher = dispatcher;
        this.params = [];
    }
    getPage() {
        return this.page;
    }
    getPath() {
        return this.path;
    }
    setData(data) {
        this.params = data.parameters;
        this.widgets = data.widgets;
    }
    getParams() {
        return this.params;
    }
    getParam(key) {
        for (let param of this.getParams()) {
            if (param.name === key) {
                return param.value;
            }
        }
    }
    change() {
        this.emitChange();
    }
    getWidgets() {
        return this.widgets;
    }
    dehydrate() {
        return {
            params: this.params,
            widgets: this.widgets,
        };
    }
    rehydrate(state) {
        this.params = state.params;
        this.widgets = state.widgets;
    }
}
ApplicationStore.storeName = 'ApplicationStore';
ApplicationStore.handlers = { NAVIGATE_SUCCESS: 'change' };
exports.default = ApplicationStore;
